module.exports = __webpack_public_path__ + "static/media/qualiphy-logo.5800b819.png";